import React from "react";
import "./StepProgress.scss";

const StepProgress = ({ steps, currentStep }) => {
  if (!steps || steps.length === 0) return <p>No steps provided.</p>;

  return (
    <div className="step-progress">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep ;
        const isActive = index === currentStep ;

        let lineClass = "default"; 
        if ( index <= currentStep) {
          lineClass = "completed-to-active"; 
        } 

        return (
          <div key={index} className="step-container">
              <div className={`step-line ${lineClass}`}></div>
            <div
              className={`step-circle ${isCompleted ? "completed" : ""} ${
                isActive ? "active" : ""
              }`}
            ></div>
            <span
              className={`step-label ${
                isCompleted ? "completed-label" : isActive ? "active-label" : ""
              }`}
            >
              {step}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default StepProgress;